function SkeletonBlock({ className = '' }: { className?: string }) {
  return (
    <span
      className={`pricing-skeleton ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

function PricesLoading() {
  return (
    <main className="new-pricing text-900 pricing-loading" aria-busy="true" aria-label="در حال بارگذاری">
      <div className="ambient ambient-one rounded-circle" />
      <div className="ambient ambient-two rounded-circle" />

      <div className="content-grid">
        <div className="configurator">
          <div className="stage-group">
            <div className="stage-heading stage-heading-row">
              <div>
                <SkeletonBlock className="pricing-skeleton-eyebrow" />
                <SkeletonBlock className="pricing-skeleton-heading" />
              </div>
              <SkeletonBlock className="pricing-skeleton-price" />
            </div>

            <section className="plans-panel rounded-4 bg-white dark__bg-card-dark">
              <div className="plans-grid">
                {Array.from({ length: 4 }, (_, index) => (
                  <div
                    key={index}
                    className="pricing-skeleton-plan-card rounded-4"
                    aria-hidden="true"
                  >
                    <SkeletonBlock className="pricing-skeleton-plan-logo rounded-4" />
                    <div className="pricing-skeleton-plan-copy">
                      <SkeletonBlock className="pricing-skeleton-plan-title" />
                      <SkeletonBlock className="pricing-skeleton-plan-subtitle" />
                    </div>
                    <SkeletonBlock className="pricing-skeleton-plan-action rounded-2" />
                  </div>
                ))}
              </div>
            </section>

            <div className="tools-comparison-card rounded-4 bg-white dark__bg-card-dark pricing-skeleton-comparison">
              <div className="pricing-skeleton-comparison-copy">
                <SkeletonBlock className="pricing-skeleton-eyebrow" />
                <SkeletonBlock className="pricing-skeleton-heading pricing-skeleton-heading-sm" />
              </div>
              <SkeletonBlock className="pricing-skeleton-button rounded-3" />
            </div>
          </div>

          <div className="addons-group">
            <div className="addons-heading">
              <SkeletonBlock className="pricing-skeleton-eyebrow" />
              <SkeletonBlock className="pricing-skeleton-heading pricing-skeleton-heading-sm" />
            </div>

            {Array.from({ length: 2 }, (_, index) => (
              <div
                key={index}
                className="pricing-skeleton-addon-card rounded-4 bg-white dark__bg-card-dark"
                aria-hidden="true"
              >
                <SkeletonBlock className="pricing-skeleton-addon-icon rounded-3" />
                <div className="pricing-skeleton-addon-copy">
                  <SkeletonBlock className="pricing-skeleton-eyebrow pricing-skeleton-eyebrow-sm" />
                  <SkeletonBlock className="pricing-skeleton-heading pricing-skeleton-heading-sm" />
                  <SkeletonBlock className="pricing-skeleton-line" />
                </div>
                <SkeletonBlock className="pricing-skeleton-switch rounded-pill" />
              </div>
            ))}
          </div>

          <div className="stage-group">
            <div className="stage-heading">
              <SkeletonBlock className="pricing-skeleton-eyebrow" />
              <SkeletonBlock className="pricing-skeleton-heading pricing-skeleton-heading-sm" />
            </div>

            <div className="period-wrap rounded-4 bg-white dark__bg-card-dark pricing-skeleton-period">
              <div className="pricing-skeleton-period-options">
                {Array.from({ length: 3 }, (_, index) => (
                  <SkeletonBlock
                    key={index}
                    className="pricing-skeleton-period-option rounded-3"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="summary-column">
          <aside className="summary-card rounded-4 bg-white dark__bg-card-dark pricing-skeleton-summary">
            <SkeletonBlock className="pricing-skeleton-badge rounded-2" />
            <div className="pricing-skeleton-summary-plan">
              <SkeletonBlock className="pricing-skeleton-summary-logo rounded-3" />
              <div className="pricing-skeleton-summary-copy">
                <SkeletonBlock className="pricing-skeleton-plan-title" />
                <SkeletonBlock className="pricing-skeleton-line pricing-skeleton-line-sm" />
              </div>
            </div>
            <div className="pricing-skeleton-summary-lines">
              {Array.from({ length: 3 }, (_, index) => (
                <div key={index} className="pricing-skeleton-summary-line">
                  <SkeletonBlock className="pricing-skeleton-line" />
                  <SkeletonBlock className="pricing-skeleton-line pricing-skeleton-line-value" />
                </div>
              ))}
            </div>
            <SkeletonBlock className="pricing-skeleton-total rounded-3" />
            <SkeletonBlock className="pricing-skeleton-terms rounded-3" />
            <SkeletonBlock className="pricing-skeleton-checkout rounded-3" />
          </aside>
        </div>
      </div>
    </main>
  );
}

export default PricesLoading;
